import type { HTMLWidget } from "~/types/widgets";
import NewsletterForm from "~/components/footer/NewsletterForm";

export const eager = true;
export const sync = true;

export interface Props {
  title?: string;
  subtitle?: string;
  disclaimer?: HTMLWidget;
  buttonText?: string;
  /** @title Mensagem de Sucesso */
  successMessage?: string;
  /** @title Texto do Cupom */
  couponText?: string;
  /** @title Código do Cupom */
  couponCode?: string;
  /**
   * @title Margin Top
   * @description Add margin to the top of the section
   */
  marginTop?: string;
}

const DEFAULT_PROPS: Props = {
  title: "Cadastre-se na nossa newsletter",
  subtitle: "Receba as novidades e ganhe 10% de desconto na primeira compra",
  disclaimer:
    '*Assinando nossa news, você está de acordo com nossa <a href="/institucional/aviso-de-privacidade">Política de Privacidade</a>',
  buttonText: "Enviar",
  successMessage: "Cadastro realizado com sucesso!",
  couponText: "Copie este cupom e ganhe 10% OFF em sua primeira compra.",
  couponCode: "PRIMEIRACOMPRA",
  marginTop: "0",
};

function Newsletter(props: Props) {
  const {
    title,
    subtitle,
    disclaimer,
    buttonText,
    successMessage,
    couponText,
    couponCode,
    marginTop,
  } = {
    ...DEFAULT_PROPS,
    ...props,
  };

  return (
    <section style={{ marginTop }}>
      <div className="pt-12 px-4 pb-12 text-center bg-[#F0F0F0] lg:px-[150px]">
        <div className="flex flex-col items-center">
          <span className="font-['Poppins'] not-italic font-medium text-lg leading-[34.8px] tracking-[0.25px] uppercase text-[#1A1A1A] lg:text-2xl">
            {title}
          </span>
          <span className="font-['Poppins'] not-italic font-normal text-[11px] lg:text-sm leading-[20.3px] tracking-[0.25px] mb-1 mx-0 text-[#434343]">
            {subtitle}
          </span>
        </div>

        <div className="flex justify-center pt-[15px]">
          <NewsletterForm
            buttonText={buttonText}
            disclaimer={disclaimer}
            successMessage={successMessage}
            couponText={couponText}
            couponCode={couponCode}
          />
        </div>
      </div>
    </section>
  );
}

export default Newsletter;
